import { render, staticRenderFns } from "./create-theater-event-email-form.vue?vue&type=template&id=6dd9d8d1"
import script from "./create-theater-event-email-form.vue?vue&type=script&lang=js"
export * from "./create-theater-event-email-form.vue?vue&type=script&lang=js"
import style0 from "./create-theater-event-email-form.vue?vue&type=style&index=0&id=6dd9d8d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports